import React, { Component } from "react";
import homedata from "../../data/home.json";

class VisiMisi extends Component {
  render() {
    let factsInfo = homedata.visionsMissions;
    let sectionHeadingInfo = factsInfo.sectionHeading;
    let featureContent = factsInfo.singleFeature;
    let publicUrl = process.env.PUBLIC_URL;

    return (
      <section id="visi_misi" className="modern-vision-section pt100 pb100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-10 col-sm-12 offset-lg-2 offset-md-1">
              <div className="section-title text-center mb60">
                <h2
                  dangerouslySetInnerHTML={{ __html: sectionHeadingInfo.title }}
                ></h2>
                <hr className="lines" />
                <p className="section-description">{sectionHeadingInfo.desc}</p>
              </div>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-5 text-center md-m-30px-b">
              <div className="vision-image-wrapper">
                <img
                  className="img-fluid vision-illustration"
                  src={publicUrl + featureContent.image}
                  alt={`visi_misi`}
                />
              </div>
            </div>

            <div className="col-lg-7">
              <div className="vision-cards">
                {featureContent.featurePart1.map((element, i) => {
                  return (
                    <div key={i} className="vision-card">
                      <div className="vision-card-icon">
                        <i className={element.icon}></i>
                      </div>
                      <div className="vision-card-content">
                        <h4>{element.title}</h4>
                        <p>{element.desc}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <style jsx="true">{`
          .modern-vision-section {
            background: white;
            position: relative;
          }

          .section-title h2 {
            font-size: 42px;
            font-weight: 700;
            color: #1a1a2e;
            margin-bottom: 15px;
          }

          .section-title h2 span {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .section-description {
            font-size: 16px;
            color: #6c757d;
            line-height: 1.8;
            margin-top: 15px;
          }

          .vision-image-wrapper {
            position: relative;
            padding: 20px;
          }

          .vision-illustration {
            animation: floatSlow 8s ease-in-out infinite;
            filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.1));
          }

          @keyframes floatSlow {
            0%,
            100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-15px);
            }
          }

          .vision-cards {
            display: flex;
            flex-direction: column;
            gap: 25px;
          }

          .vision-card {
            display: flex;
            gap: 20px;
            padding: 30px;
            background: white;
            border-radius: 16px;
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            border: 1px solid #f0f0f0;
          }

          .vision-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 40px rgba(102, 126, 234, 0.15);
            border-color: #667eea;
          }

          .vision-card-icon {
            flex-shrink: 0;
            width: 60px;
            height: 60px;
            border-radius: 12px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
          }

          .vision-card-icon i {
            font-size: 28px;
            color: white;
          }

          .vision-card-content h4 {
            font-size: 22px;
            font-weight: 700;
            color: #1a1a2e;
            margin-bottom: 10px;
          }

          .vision-card-content p {
            font-size: 15px;
            line-height: 1.7;
            color: #4a5568;
            margin: 0;
          }

          @media (max-width: 991px) {
            .section-title h2 {
              font-size: 32px;
            }

            .vision-cards {
              margin-top: 30px;
            }

            .vision-card {
              padding: 20px;
            }

            .vision-card-icon {
              width: 50px;
              height: 50px;
            }

            .vision-card-icon i {
              font-size: 24px;
            }

            .vision-card-content h4 {
              font-size: 18px;
            }
          }
        `}</style>
      </section>
    );
  }
}

export default VisiMisi;
